import { computed, inject, ref } from 'vue';
import { useStore } from 'vuex';
import { PROJECT_TYPES } from '@/app/data/model_constants';
import { FT } from '@/app/data/flipper_constants';
import INJECT_KEYS from '@/app/data/inject_keys';

export default function useProjectCreate() {
  const store = useStore();
  const flipper = inject(INJECT_KEYS.FLIPPER);

  const limit_reached_modal = ref(false);
  const project_modal = ref(false);
  const loaded_project_templates = ref(false);

  const current_client = computed(() => store.getters.current_client);

  const remaining_unit_count = computed(
    () => current_client.value.attributes.units_active_count_max - current_client.value.attributes.units_active_count,
  );

  const is_limit_reached = computed(
    () => current_client.value.attributes.project_type === PROJECT_TYPES.SUP && remaining_unit_count.value <= 0,
  );

  async function openProjectCreate() {
    if (is_limit_reached.value) {
      limit_reached_modal.value = true;
      return;
    }
    if (flipper.enabled(FT.TEMPLATE_PROJECTS) && !loaded_project_templates.value) {
      await store.dispatch('FETCH_PROJECTS', { skip_customer: true });
      loaded_project_templates.value = true;
    }
    project_modal.value = true;
  }

  return { limit_reached_modal, project_modal, loaded_project_templates, openProjectCreate };
}
